import React from 'react';
import { Text } from 'pp-react';

import styles from './charityLogo.less';

import content from '../lib/i18n';
import { isPPGF } from '../lib/charity';
const i18n = content('hub/components/charityLogo');

export default class extends React.Component {
  render() {
    let title;

    if (isPPGF(this.props.charity_type)) {
      title = i18n('label.donate-with-ppgf');
    }

    const logoUrl =
      this.props.logo_url ||
      'https://www.paypalobjects.com/images/Cause/ic_donate1.svg';
    return (
      <div
        className={`npo-logo-container ${
          this.props.campaign ? `${styles['campaign-margin']}` : ''
        }`}
      >
        <div className={'npo-avatar-container'}>
          <div
            className={'npo-avatar'}
            style={{
              background: `url(${logoUrl}) no-repeat center, center`,
              backgroundSize: 'contain',
            }}
          />
        </div>
        <div className={'npo-logo-title'}>
          <Text as='p' size='md'>
            {title}
          </Text>
          <Text as='h1' size='xl3'>
            {this.props.name}
          </Text>
        </div>
      </div>
    );
  }
}
